import { z, ZodSchema } from "zod"

export const handleTypeGuardError = <T extends ZodSchema<unknown>>(
  schema: T,
  payload: unknown
): payload is z.infer<T> => {
  // 運行時邏輯：使用 safeParse 驗證
  return schema.safeParse(payload).success
}

export default handleTypeGuardError
